import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/AssignmentTurnedInRounded';

class AssignmentTurnedInRoundedIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default AssignmentTurnedInRoundedIcon;
